import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("aranya_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => {
      const field = Array.isArray(e?.loc) ? e.loc.filter((x) => x !== "body").slice(-1)[0] : null;
      const msg = e && typeof e.msg === "string" ? e.msg : JSON.stringify(e);
      return field ? `${field}: ${msg}` : msg;
    }).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export async function downloadFile(path, filename) {
  const res = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export function authFileUrl(path) {
  const token = localStorage.getItem("aranya_token") || "";
  return `${API}/files/${path}?auth=${encodeURIComponent(token)}`;
}

export default api;
